import { useNavLink } from '@acp/feature/auth';
import { MenuItem, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export type NavigationItemProps = {
    to?: string;
    label: string;
    isExternal?: boolean;
    onClick?: () => void;
};

export function NavigationMenuItem({
    to,
    label,
    isExternal = false,
    onClick,
}: NavigationItemProps) {
    const href = useNavLink({ to, isExternal });

    return (
        <MenuItem
            as={onClick === undefined ? Link : undefined}
            to={href ?? ''}
            onClick={onClick}
        >
            <Text fontSize="sm" py={1}>
                {label}
            </Text>
        </MenuItem>
    );
}
